interface ColorPickerProps {
  colors: string[]
  value: string
  onChange: (color: string) => void
}

export function ColorPicker({ colors, value, onChange }: ColorPickerProps) {
  return (
    <div className="color-picker">
      <button
        type="button"
        className={`color-swatch color-swatch-none${!value ? ' selected' : ''}`}
        onClick={() => onChange('')}
        title="No color"
      >✕</button>
      {colors.map(c => (
        <button
          key={c}
          type="button"
          className={`color-swatch color-swatch-${c}${value === c ? ' selected' : ''}`}
          onClick={() => onChange(c)}
          title={c}
        />
      ))}
    </div>
  )
}
